import {
  DeleteOutlined,
  DownloadOutlined,
  EyeOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Input,
  Popconfirm,
  Select,
  Space,
  Table,
  TableColumnType,
  Tag,
} from "antd";
import { useState } from "react";
import { DocumentType } from "../../enum/common";
import { IProjectDocuments } from "../../models/Research";
import {
  useDeleteDocumentProject,
  useGetDocumentByProjectId,
  useGetResearchProject,
} from "../../query/ReseachQuery";
import { researchService } from "../../services/researchService";
import { notify } from "../../utils/toast";
import ModalUploadDocumentResearch from "../modal/ModalUploadDocumentResearch";
import ModalViewDocumentDetail from "../modal/ModalViewDocumentDetail";
import { useSelector } from "react-redux";
import { PositionCode, UserRole } from "../../enum/roles";
import { RootState } from "../../store";
interface ProjectBudgetTabProps {
  alias: string;
}
const ProjectDocument = ({ alias }: ProjectBudgetTabProps) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalView, setOpenModalView] = useState<boolean>(false);
  const [selectedDocument, setSelectedDocument] =
    useState<IProjectDocuments | null>(null);
  const [searchText, setSearchText] = useState<string>("");
  const [filterCategory, setFilterCategory] = useState<
    DocumentType | undefined
  >(undefined);
  const [downloadingId, setDownloadingId] = useState<number | null>(null);

  const { data: project } = useGetResearchProject(alias);
  const { data: projectDocument, isLoading: projectDocumentLoading } =
    useGetDocumentByProjectId(Number(project?.id));
  const user = useSelector((state: RootState) => state.auth.user);
  const isRndManager =
    user?.user?.position?.positionCode === PositionCode.RND_MANAGER ||
    user?.user?.role.includes(UserRole.ADMIN);
  const deleteDocument = useDeleteDocumentProject();

  const handleDownload = async (document: IProjectDocuments) => {
    if (!document) return;
    try {
      setDownloadingId(document.id);
      const url = await researchService.downloadDocumentProject(document.id);
      window.open(url, "_blank");
      notify.success("Tải file thành công!");
    } catch (error: any) {
      notify.error(error?.message || "Không thể tải file");
    } finally {
      setDownloadingId(null);
    }
  };
  const filteredDocuments = projectDocument?.filter((doc) => {
    const matchSearch = searchText
      ? doc.fileName.toLowerCase().includes(searchText.toLowerCase())
      : true;
    const matchCategory = filterCategory
      ? doc.documentType === filterCategory
      : true;
    return matchSearch && matchCategory;
  });
  const handleDelete = async (id: number) => {
    try {
      await deleteDocument.mutateAsync(id);
      notify.success("Xóa tài liệu thành công");
    } catch (error) {
      notify.error("Xóa tài liệu thất bại");
    }
  };

  const getTagColor = (index: number) => {
    const tagColors = ["green", "blue", "red", "orange", "purple"];
    return tagColors[index % tagColors.length];
  };

  const column: TableColumnType<IProjectDocuments>[] = [
    {
      title: "File",
      dataIndex: "fileName",
      key: "fileName",
    },
    {
      title: "Danh mục",
      dataIndex: "documentType",
      key: "documentType",
      render(value) {
        switch (value) {
          case DocumentType.DESIGN:
            return <Tag color="green">Thiết kế</Tag>;
          case DocumentType.BOM:
            return <Tag color="volcano">BOM</Tag>;
          case DocumentType.DOCUMENTATION:
            return <Tag color="geekblue">Tài liệu chung</Tag>;
          case DocumentType.SPECIFICATION:
            return <Tag color="purple">Thông số kỹ thuật</Tag>;
          case DocumentType.TEST_REPORT:
            return <Tag color="red">Báo cáo thử nghiệm</Tag>;
          default:
            return <Tag color="default">Khác</Tag>;
        }
      },
    },
    {
      title: "Phiên bản",
      dataIndex: "version",
      key: "version",
    },
    {
      title: "Tags",
      dataIndex: "tags",
      key: "tags",
      render(value) {
        return (
          <>
            {value?.map((v: string, index: number) => (
              <Tag color={getTagColor(index)} key={v}>
                {v}
              </Tag>
            ))}
          </>
        );
      },
    },
    {
      title: "Ngày upload",
      dataIndex: "createdAt",
      key: "createdAt",
      render(value) {
        return new Date(value).toLocaleDateString("vi-VI");
      },
    },
    {
      title: "Thao tác",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      render(value, record) {
        return (
          <Space>
            <EyeOutlined
              onClick={() => {
                setSelectedDocument(record);
                setOpenModalView(true);
              }}
              style={{ fontSize: 20, color: "blue", cursor: "pointer" }}
            />
            {isRndManager && (
              <>
                <DownloadOutlined
                  onClick={() => handleDownload(record)}
                  style={{ fontSize: 20, color: "green", cursor: "pointer" }}
                />
                <Popconfirm
                  onConfirm={() => handleDelete(record.id)}
                  title="Xóa tài liệu"
                  description="Bạn có chắc chắn muốn xóa tài liệu này?"
                >
                  <DeleteOutlined
                    style={{ fontSize: 20, color: "red", cursor: "pointer" }}
                  />
                </Popconfirm>
              </>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <div style={{ position: "relative" }}>
        {downloadingId !== null && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(4px)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Card
              style={{
                textAlign: "center",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
                minWidth: "300px",
              }}
            >
              <Space direction="vertical" size="middle">
                <DownloadOutlined
                  style={{
                    fontSize: "64px",
                    color: "#52c41a",
                  }}
                />
                <div>
                  <h3 style={{ margin: 0, fontSize: "18px" }}>
                    Đang lấy link download...
                  </h3>
                  <p style={{ margin: "8px 0 0", color: "#8c8c8c" }}>
                    Vui lòng đợi trong giây lát
                  </p>
                </div>
              </Space>
            </Card>
          </div>
        )}

        <Card
          title={`Tài liệu dự án ${alias}`}
          style={{ width: "100%" }}
          extra={
            <Button
              onClick={() => setOpenModal(true)}
              icon={<UploadOutlined />}
              type="primary"
            >
              Upload tài liệu
            </Button>
          }
        >
          <Input
            placeholder="Tìm kiếm theo tên file"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            allowClear
          />
          <Select
            style={{ width: "100%", marginTop: 20 }}
            placeholder="Lọc theo loại tài liệu"
            value={filterCategory}
            onChange={(value) => setFilterCategory(value)}
            allowClear
            options={[
              {
                value: DocumentType.DESIGN,
                label: "Thiết kế",
              },
              {
                value: DocumentType.BOM,
                label: "BOM",
              },
              {
                value: DocumentType.DOCUMENTATION,
                label: "Tài liệu chung",
              },
              {
                value: DocumentType.SPECIFICATION,
                label: "Thông số kỹ thuật",
              },
              {
                value: DocumentType.TEST_REPORT,
                label: "Báo cáo thử nghiệm",
              },
              {
                value: DocumentType.OTHER,
                label: "Khác",
              },
            ]}
          />
          <Table
            columns={column}
            dataSource={filteredDocuments}
            loading={projectDocumentLoading}
            rowKey="id"
            style={{ marginTop: 20 }}
            scroll={{ x: 1000 }}
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              showTotal: (total) => `Tổng ${total} tài liệu`,
            }}
          />
        </Card>
      </div>

      {project && (
        <ModalUploadDocumentResearch
          projectId={project.id}
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
        />
      )}
      <ModalViewDocumentDetail
        isOpen={openModalView}
        onClose={() => {
          setOpenModalView(false);
          setSelectedDocument(null);
        }}
        document={selectedDocument}
      />
    </>
  );
};

export default ProjectDocument;
